"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeProperty = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var isDataDescriptor = function isDataDescriptor(descriptorObject) {
  return descriptorObject.hasOwnProperty("value");
};

/**
 * Decorator function to observe the change of a property value
 * It calls the original set or get if there was any
 * @param {object} object
 * @param {string|number|symbol} prop
 * @param {function} onChange
 */
var observeProperty = exports.observeProperty = function observeProperty(object, prop, onChange) {
  var descriptor = Object.getOwnPropertyDescriptor(object, prop);
  var _get = descriptor.get,
    _set = descriptor.set;
  var _value;
  var dispose = function dispose() {
    if (isDataDescriptor(descriptor)) {
      Object.defineProperty(object, prop, _objectSpread(_objectSpread({}, descriptor), {}, {
        value: _value
      }));
    } else {
      Object.defineProperty(object, prop, descriptor);
    }
  };
  Object.defineProperty(object, prop, {
    set: function set(value) {
      if (value !== _value) {
        _value = value;
        _set && _set.call(object, value);
        onChange({
          prop: prop,
          value: value,
          dispose: dispose
        });
      }
    },
    get: function get() {
      return _get ? _get.call(object) : _value;
    }
  });
};